// extracted by mini-css-extract-plugin
export default {"empty":"WeightValue_empty__BfHmw","kilograms":"WeightValue_kilograms__snRfJ"};